// extracted by mini-css-extract-plugin
module.exports = {"content":"ActiveOverview_content__mTr2U"};